import { FileModel } from "../shared/file.model";
export class SearchLinkManualModel{
    name:number = 0
}

export class SearchELiLinkManualModel{
    pageNumber:number = 0
    criteria: LinkManualItemCriteriaModel[] = []
    pageSize:number = 0
    sort: LinkManualItemsortModel[] = []
}
export class LinkManualItemCriteriaModel {
    detail:string=''
    lmStart:string=''
    lmEnd:string=''
}
export class LinkManualItemsortModel {
    column:string=''
    direction:string=''
}

export class LinkManualItemModel{
    lmId : number = 0
    lmCode:number=0
    lmDetail:string=''
    lmUrl:string=''
    lmType:string=''
    status:number = 0
    userName: string = null!
    updateDate:string =''

}

export class LinkManualItemCUModel{
    id : number = 0
    sequence:number=0
    name:string='' //Detail
    downloadLink:string='' //URL
    size:string=''
    userName: string = null!
}
export class LinkManualCuCreateGetUIModel{
    lmCode:number=0
    lmDetail:string=''
    lmUrl:string =''
    lmType:string =''
    status:string=''
    Sstatus:boolean= false
}

export class LinkManualCuCreateModel{
        lmCode:number=0
        lmDetail:string=''
        lmUrl:string=''
        lmType:string =''
        status:string=''
    
}

export class LinkManualMenuAuthModel{
    menuAuth:number=0
}

export class LinkManualCuUpdateModel{
    lmId : number = 0
    lmCode:number = 0
    lmDetail:string = ''
    lmUrl:string = ''
    lmType:string = ''
    status:string = ''
}

export class LinkManualCuUpdateUIModel{
    lmId : number = 0
    lmCode:number = 0
    lmDetail:string = ''
    lmUrl:string = ''
    lmType:string = ''
    status:string = ''
    Sstauus:boolean=false
}
export class LinkManualByIDModel{
    lmId : number = 0

}

